import BaseProxy from '../base-proxy';

/**
 * Class AnnouncementProxy
 */
class AnnouncementProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/seller-template-announcement', parameters);
    this.defaultOptions = { allowToast: false };
  }

  getActiveAnnouncementLines(options = {}) {
    return this.submit('post', `${this.endpoint}/list-active-announce-lines`, null, { ...this.defaultOptions, ...options });
  }

}

export default AnnouncementProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/announcement-proxy.js